/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { injectIntl } from 'react-intl';
import {
  Button,
  Col,
  ControlLabel,
  Form,
  FormControl,
  FormGroup,
} from 'react-bootstrap';
import Select from 'loracoms/Select';
import ControlTips from 'loracoms/ControlTips';
import FormBlock from 'loracoms/FormBlock';
import ErrorSet from 'lorautils/errors/ErrorSet';
import IntlMsg from 'lorautils/intl/IntlMsg';
import { isNumber } from 'lorautils/checkers/numbers';
import styles from './styles.scss';


const kFreqRange = {
  EU863: {
    min: 863,
    max: 870,
  },
  CN470PREQUEL: {
    min: 470,
    max: 510,
  },
  EU868SEMTECH: {
    min: 863,
    max: 870,
  },
  AS923: {
    min: 915,
    max: 928,
  },
};

const kTypeOptions = [{
  label: 'LoRa',
  value: 'lora',
}, {
  label: 'FSK',
  value: 'fsk',
}];

const getTypeOpts = (dataRates) => {
  if (_.isNil(dataRates) || _.isEmpty(dataRates)) {
    return kTypeOptions;
  }
  const types = _.toPairs(dataRates).filter(p => p[1].length > 0).map(p => p[0]);
  return kTypeOptions.filter(opt => types.includes(opt.value));
};

const dataRateLabels = {
  fsk: (
    dr => (
      <span>
        {dr.dr}
        <span className={styles.infos}>
          <span className={styles.info}>
            <i className="fa fa-angle-left" />
            bit rate: {dr.bitrate}
            <i className="fa fa-angle-right" />
          </span>
        </span>
      </span>
    )),
  lora: (
    dr => (
      <span>
        {dr.dr}
        <span className={styles.infos}>
          <span className={styles.info}>
            <i className="fa fa-angle-left" />
            band width: {dr.bandwidth}k
            <i className="fa fa-angle-right" />
          </span>
          <span className={styles.info}>
            <i className="fa fa-angle-left" />
            SF: {dr.sf}
            <i className="fa fa-angle-right" />
          </span>
        </span>
      </span>
    )),
};

const propTypes = {
  dataRates: React.PropTypes.object.isRequired,
  band: React.PropTypes.string.isRequired,
  channels: React.PropTypes.array.isRequired,
  onAdd: React.PropTypes.func.isRequired,
  intl: React.PropTypes.object.isRequired,
};

class AddChannelForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      band: props.band,
      dataRates: props.dataRates,
      channels: props.channels,
      errors: (
        ErrorSet
          .createEmpty()
          .add('FE_EMPTY', 'freq')
          .add('FE_EMPTY', 'mindr')
          .add('FE_EMPTY', 'maxdr')
      ),
    };
    this.intlMsg = new IntlMsg(props.intl, 'network.channelview.add.free');
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChangeFreq = this.handleChangeFreq.bind(this);
    this.handleChangeMinDR = this.handleChangeMinDR.bind(this);
    this.handleChangeMaxDR = this.handleChangeMaxDR.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const { band, dataRates, channels } = nextProps;
    if (band !== this.props.band) {
      this.setState({ band });
    }
    if (dataRates !== this.props.dataRates) {
      this.setState({ dataRates });
    }
    if (channels !== this.props.channels) {
      this.setState({ channels });
      const { errors, freq = '' } = this.state;
      if (freq !== '' &&
          channels.findIndex(ch => ch.freq === freq * 1000000) < 0 &&
          errors.getCode('freq') === 'FE_DUPFREQ') {
        this.setState({ errors: errors.remove('freq') });
      }
    }
  }

  handleChangeFreq(e) {
    const freq = e.target.value.trim();
    const { errors, band, channels = [] } = this.state;

    this.setState({ freq });

    if (freq === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'freq') });
    } else if (isNumber(freq, { ...kFreqRange[band], points: { max: 4 } })) {
      if (channels.findIndex(ch => ch.freq === freq * 1000000) >= 0) {
        this.setState({ errors: errors.add('FE_DUPFREQ', 'freq') });
      } else {
        this.setState({ errors: errors.remove('freq') });
      }
    } else {
      this.setState({ errors: errors.add('FE_INVALIDFREQ', 'freq') });
    }
  }

  handleChangeMinDR(mindr) {
    const { maxdr, errors } = this.state;
    this.setState({ mindr });

    if (!_.isNil(maxdr)) {
      if (maxdr < mindr) {
        this.setState({
          errors: errors.add('FE_MINGTMAX', 'mindr').add('FE_MINGTMAX', 'maxdr'),
        });
      } else {
        this.setState({
          errors: errors.remove('mindr').remove('maxdr'),
        });
      }
    } else {
      this.setState({
        errors: errors.remove('mindr'),
      });
    }
  }

  handleChangeMaxDR(maxdr) {
    const { mindr, errors } = this.state;
    this.setState({ maxdr });

    if (!_.isNil(mindr)) {
      if (maxdr < mindr) {
        this.setState({
          errors: errors.add('FE_MINGTMAX', 'mindr').add('FE_MINGTMAX', 'maxdr'),
        });
      } else {
        this.setState({
          errors: errors.remove('mindr').remove('maxdr'),
        });
      }
    } else {
      this.setState({
        errors: errors.remove('maxdr'),
      });
    }
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ submitted: true });

    const { onAdd } = this.props;
    const { freq, mindr, maxdr, channels } = this.state;
    let { errors } = this.state;

    if (channels.findIndex(ch => ch.freq === freq * 1000000) >= 0) {
      errors = errors.add('FE_DUPFREQ', 'freq');
      this.setState({ errors });
    }

    if (!errors.isEmpty()) {
      return;
    }

    onAdd({
      freq: freq * 1000000,
      mindr,
      maxdr,
    });
  }

  render() {
    const {
      freq = '',
      dataRates = {},
      type = 'lora',
      band = '',
      errors,
      submitted = false,
    } = this.state;
    let {
      minDr,
      maxDr,
    } = this.state;
    const {
      min: minRange = 0,
      max: maxRange = 0,
    } = kFreqRange[band] || {};
    const drs = dataRates[type] || [];

    if (_.isNil(minDr)) {
      minDr = drs[0];
    }
    if (_.isNil(maxDr)) {
      maxDr = drs[0];
    }

    const drOpts = drs.map(dr => ({
      label: dr.dr,
      value: dr.dr,
      formatter: () => dataRateLabels[type](dr),
    }));

    return (
      <Form
        className={styles.form}
        horizontal
        onSubmit={this.handleSubmit}
      >
        <FormGroup validationState={submitted && errors.has('freq') ? 'error' : undefined}>
          <Col md={2}>
            <ControlLabel className="aisz-control-label">
              {this.intlMsg.msg('freq')}
            </ControlLabel>
          </Col>
          <Col md={8}>
            <FormControl
              bsClass="aisz-form-control-f"
              placeholder={`${minRange}MHz ~ ${maxRange}MHz`}
              value={freq}
              onChange={this.handleChangeFreq}
            />
            <ControlTips
              show={submitted && errors.has('freq')}
              message={this.intlMsg.errorMsg(errors.get('freq'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
        <FormGroup>
          <Col md={2}>
            <ControlLabel className="aisz-control-label">
              {this.intlMsg.msg('type')}
            </ControlLabel>
          </Col>
          <Col md={8}>
            <Select
              value={type}
              options={getTypeOpts(dataRates)}
              onChange={(v) => { this.setState({ type: v }); }}
            />
          </Col>
        </FormGroup>
        <FormGroup validationState={submitted && errors.has('mindr') ? 'error' : undefined}>
          <Col md={2}>
            <ControlLabel className="aisz-control-label">
              Min DR
            </ControlLabel>
          </Col>
          <Col md={8}>
            <Select
              options={drOpts}
              value={minDr}
              onChange={this.handleChangeMinDR}
            />
            <ControlTips
              show={submitted && errors.has('mindr')}
              message={this.intlMsg.errorMsg(errors.get('mindr'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
        <FormGroup validationState={submitted && errors.has('maxdr') ? 'error' : undefined}>
          <Col md={2}>
            <ControlLabel className="aisz-control-label">
              Max DR
            </ControlLabel>
          </Col>
          <Col md={8}>
            <Select
              options={drOpts}
              value={maxDr}
              onChange={this.handleChangeMaxDR}
            />
            <ControlTips
              show={submitted && errors.has('maxdr')}
              message={this.intlMsg.errorMsg(errors.get('maxdr'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
        <FormGroup>
          <Col mdOffset={2} md={8}>
            <div className={styles.submit}>
              <Button
                bsStyle="aisz-primary"
                type="submit"
              >
                <span className="halflings halflings-plus" />
                {' '}
                {this.intlMsg.msg('addch')}
              </Button>
            </div>
            <FormBlock
              show={submitted && errors.has('submit')}
              message={this.intlMsg.errorMsg(errors.get('submit'))}
              azStyle="danger"
            />
          </Col>
        </FormGroup>
      </Form>
    );
  }
}

AddChannelForm.propTypes = propTypes;

export default injectIntl(AddChannelForm);




// WEBPACK FOOTER //
// ./src/containers/Network/coms/ChannelView/coms/AddChannelForm/index.jsx